/* eslint-disable key-spacing */
export const defaultLoaderTheme = {
  bodyOverflow:             'global-loader-overflow',
  container:                'loader-container',
  element:                  'loader-element',
  fullscreen:               'fullscreen',
  wrapper:                  'loader-wrapper',
};
/* eslint-enable key-spacing */
